export enum SharedIconState {
  Default = 0,
  Empty = 1,
  Shared = 2,
  Mixed = 3,
  Exception = 4,
};
